import React from 'react';
import CrewScheduleSystem from './CrewScheduleSystem';

const CrewSchedule: React.FC = () => {
  return <CrewScheduleSystem />;
};

export default CrewSchedule;
